module.exports = __webpack_public_path__ + "img/phaseiv.6855c82d.png";